import {
  AddWaypointAction,
  GetRouteOptApiAction,
  InitalizeCourseStateAction,
  RemoveWaypointAction,
  ResultsErrorAction,
  SetMilesAction,
  SetResultsAction,
  SetWaypointsAction,
  ToggleFromCurrLocAction,
  ToggleWaypointEditModeAction,
  UpdateWaypoint,
} from '@course-planning-store';
import { createReducer, on } from '@ngrx/store';
import { IStoreCourseState } from '@shared/modules/course-planning/store/course-state.model';

const initialState: IStoreCourseState = {
  waypoints: [],
  calculatedMiles: 0,
  waypointEditing: false,
  loading: false,
  results: {
    model: 'Konnecta Model',
    dt: [],
    foc: [],
    segments: [],
    speed: [],
    summary: [],
    ws: [],
  },
  // results: {
  //   model: 'Danaos Model',
  //   segments: [
  //     [23.708, 37.4],
  //     [23.708, 36.9],
  //     [23.708, 36.4],
  //     [22.52, 36.4],
  //     [21.52, 36.4],
  //     [20.52, 36.4],
  //     [19.52, 36.4],
  //     [18.52, 36.4],
  //     [17.52, 36.4],
  //     [16.52, 36.4],
  //     [15.52, 36.4],
  //   ],
  //   dt: [
  //     '2022-02-02 12:00',
  //     '2022-02-02 14:29',
  //     '2022-02-02 16:51',
  //     '2022-02-02 20:57',
  //     '2022-02-03 00:24',
  //     '2022-02-03 03:51',
  //     '2022-02-03 06:52',
  //     '2022-02-03 09:53',
  //     '2022-02-03 12:54',
  //     '2022-02-03 15:51',
  //     '2022-02-03 18:48',
  //   ],
  //   speed: [12, 12, 12.6, 14, 14, 14, 16, 16, 16, 16.4, 16.4],
  //   ws: [
  //     28.22688, 32.50368, 30.07368, 29.5488, 10.36152, 17.2044, 18.79848,
  //     18.29304, 11.62512, 11.0808, 12.90816,
  //   ],
  //   wd: [
  //     8.72, 6.61, 13.43, 10.1, 52.47, 12.62, 355.26, 347.57, 336.05, 243.44,
  //     236.92,
  //   ],
  //   foc: [
  //     11.8532114029, 11.1155424118, -0.2632021606, 19.7921485901, -0.1635860205,
  //     94.2054214478, 14.3784036636, 95.8962173462, 96.0980987549, 94.1364059448,
  //     94.1364059448,
  //   ],
  //   total_miles: 123,
  //   avg_speed: 3412,
  //   total_h: 2,
  //   total_foc: 45,
  //   total_emm: 1.893,
  //   cii: 443,
  // },
  fromCurr: true,
};
const CourseReducers = createReducer(
  initialState,
  on(InitalizeCourseStateAction, (state) => {
    return { ...state, results: initialState.results };
  }),
  on(AddWaypointAction, (state, { waypoint, onStart = false }) => {
    if (onStart) {
      const waypoints = [waypoint, ...state.waypoints];
      return { ...state, waypoints };
    } else {
      const waypoints = [...state.waypoints, waypoint];
      return { ...state, waypoints };
    }
  }),
  on(RemoveWaypointAction, (state, { id }) => {
    const waypoints = state.waypoints.filter((w) => w.id !== id);
    return { ...state, waypoints };
  }),
  on(SetMilesAction, (state, { miles }) => {
    return { ...state, calculatedMiles: miles };
  }),

  on(SetWaypointsAction, (state, { waypoints }) => {
    return { ...state, waypoints };
  }),
  on(ToggleWaypointEditModeAction, (state, { enableEdit }) => {
    let newToggleState = !state.waypointEditing;

    if (enableEdit !== undefined) newToggleState = enableEdit;

    return { ...state, waypointEditing: newToggleState };
  }),

  on(UpdateWaypoint, (state, { id, lat, lng }) => {
    const pointIndex = state.waypoints.findIndex((w) => w.id === id);
    if (pointIndex === -1) return { ...state };

    const waypoints = [...state.waypoints];
    waypoints[pointIndex] = { ...waypoints[pointIndex], lat, lng };
    return { ...state, waypoints };
  }),
  on(GetRouteOptApiAction, (state) => {
    return { ...state, loading: true };
  }),
  on(SetResultsAction, (state, { results }) => {
    return {
      ...state,
      results,
      loading: false,
    };
  }),
  on(SetResultsAction, (state, { results }) => {
    return {
      ...state,
      results,
      loading: false,
    };
  }),

  on(ToggleFromCurrLocAction, (state, { fromCurr }) => {
    return {
      ...state,
      fromCurr,
    };
  }),
  on(ResultsErrorAction, (state) => {
    return {
      ...state,
      loading: false,
    };
  })
);

export { CourseReducers };
